import React from "react";

/* 🔹 Reusable bilingual content */
export const JoyrideContent = ({ en, hi }) => (
  <div

  >
    <div style={{ fontWeight: 500,  }}>{en}</div>
    <div style={{ fontWeight: 500, marginTop:'4px' }}>{hi}</div>
  </div>
);

/* =====================================================
   📌 DOCUMENT EVENT SELECTION TOUR STEPS
   ===================================================== */

export const documentEventSteps = ({ navigate }) => [
  {
    target: '[data-tour="event-select"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideFooter: true,
    speechText:"Select the event for which you want to create documents.",
    content: (
      <JoyrideContent
        en="Select the event for which you want to create documents."
        hi="जिस कार्यक्रम के लिए आप दस्तावेज़ बनाना चाहते हैं, उसे चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="activity-select"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideFooter: true,
    speechText:"Select the activity related to the selected event.",
    content: (
      <JoyrideContent
        en="Select the activity related to the selected event."
        hi="चयनित कार्यक्रम से संबंधित गतिविधि चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="event-submit"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideFooter: true,
    speechText: "Click here to submit the event.",
  content: (
    <JoyrideContent
      en="Click here to submit the event."
      hi="कार्यक्रम सबमिट करने के लिए यहाँ क्लिक करें।"
    />
    ),
  },
];

export const documentsTourSteps = () => [
  {
    target: '[data-tour="document-categories"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Select a category.",
    content: (
      <JoyrideContent
        en="Select a category"
        hi="कोई श्रेणी चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="documents-list"]',
    placement: "right",
    disableBeacon: true,
    hideFooter: true,
    disableOverlay: true,
    speechText: "Click any document.",
    content: (
      <JoyrideContent
        en="Click any document"
        hi="दस्तावेज़ पर क्लिक करें।"
      />
    ),
  },
];


